export default "__VITE_ASSET__B70aHfpk__"